var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiv13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.28125,
    width: 46,
    height: 46,
    rx: 13,
    fill: "#06BA63"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4688 19.375H20.4688V26.285H22.4688V19.375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4688 11.4141H20.4688V16.244H22.4688V11.4141Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5156 11.2266H18.5156V13.2266H24.5156V11.2266Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4777 35.3354C19.7054 35.3176 17.9698 34.8292 16.4484 33.92C14.927 33.0109 13.6746 31.7137 12.8194 30.1613C11.9642 28.609 11.5369 26.8573 11.5813 25.0855C11.6256 23.3137 12.1401 21.5856 13.072 20.078C14.0039 18.5705 15.3197 17.3377 16.8846 16.5058C18.4496 15.674 20.2076 15.273 21.9785 15.344C23.7494 15.4149 25.4696 15.9552 26.963 16.9096C28.4564 17.864 29.6694 19.1982 30.4777 20.7754C30.5577 20.9254 30.6277 21.0854 30.6977 21.2454L28.8677 22.0454C28.8077 21.9254 28.7577 21.7954 28.6877 21.6754C28.0389 20.4147 27.0668 19.349 25.8707 18.5875C24.6747 17.8259 23.2978 17.396 21.8809 17.3416C20.4641 17.2872 19.0582 17.6104 17.8074 18.278C16.5565 18.9456 15.5055 19.9336 14.7621 21.141C14.0186 22.3483 13.6094 23.7316 13.5763 25.1491C13.5432 26.5666 13.8875 27.9674 14.5738 29.2081C15.2601 30.4488 16.2638 31.4848 17.4822 32.21C18.7006 32.9353 20.0898 33.3237 21.5077 33.3354C22.0857 33.336 22.6622 33.2757 23.2277 33.1554L23.6577 35.1054C22.9411 35.2587 22.2104 35.3358 21.4777 35.3354Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4688 27.2891C22.2972 27.2891 22.9688 26.6175 22.9688 25.7891C22.9688 24.9606 22.2972 24.2891 21.4688 24.2891C20.6403 24.2891 19.9688 24.9606 19.9688 25.7891C19.9688 26.6175 20.6403 27.2891 21.4688 27.2891Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8106 14.5331L25.8125 17.5312L27.2267 18.9455L30.2249 15.9473L28.8106 14.5331Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4141 33.2266C28.6229 33.2266 27.8496 32.992 27.1918 32.5524C26.534 32.1129 26.0213 31.4882 25.7186 30.7573C25.4158 30.0264 25.3366 29.2221 25.4909 28.4462C25.6453 27.6703 26.0262 26.9576 26.5856 26.3981C27.145 25.8387 27.8578 25.4578 28.6337 25.3034C29.4096 25.1491 30.2139 25.2283 30.9448 25.5311C31.6757 25.8338 32.3004 26.3465 32.7399 27.0043C33.1795 27.6621 33.4141 28.4355 33.4141 29.2266C33.4141 30.2874 32.9926 31.3049 32.2425 32.055C31.4923 32.8052 30.4749 33.2266 29.4141 33.2266ZM29.4141 27.2266C29.0185 27.2266 28.6318 27.3439 28.3029 27.5636C27.974 27.7834 27.7177 28.0957 27.5663 28.4612C27.4149 28.8266 27.3753 29.2288 27.4525 29.6167C27.5297 30.0047 27.7201 30.3611 27.9998 30.6408C28.2796 30.9205 28.6359 31.111 29.0239 31.1881C29.4118 31.2653 29.814 31.2257 30.1794 31.0743C30.5449 30.923 30.8572 30.6666 31.077 30.3377C31.2968 30.0088 31.4141 29.6221 31.4141 29.2266C31.4141 28.6961 31.2034 28.1874 30.8283 27.8124C30.4532 27.4373 29.9445 27.2266 29.4141 27.2266Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4297 23.2266H28.4297V26.2266H30.4297V23.2266Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4297 32.2266H28.4297V35.2266H30.4297V32.2266Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4297 28.2266H32.4297V30.2266H35.4297V28.2266Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4297 28.2266H23.4297V30.2266H26.4297V28.2266Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2582 30.6563L30.8438 32.0703L32.9647 34.192L34.3792 32.778L32.2582 30.6563Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8908 24.2889L24.4766 25.7031L26.5979 27.8244L28.0121 26.4102L25.8908 24.2889Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9729 24.2615L30.8516 26.3828L32.2658 27.797L34.3871 25.6757L32.9729 24.2615Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6057 30.6209L24.4844 32.7422L25.8986 34.1564L28.0199 32.0351L26.6057 30.6209Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiv13);
export default __webpack_public_path__ + "static/media/div13.eb849b24186dc27310deec9dcca2916c.svg";
export { ForwardRef as ReactComponent };